import { AppRoutes } from 'AppRoutes';
import { buildAPI } from 'consts/api';
import { DEFAULT_APP_CONFIG } from 'consts/config';
import { useEffect, useState } from 'react';
import { HandleResponse } from 'services/http';
import { type AppConfig, isValidAppConfig } from 'types';

export default function App() {
	const [config, setConfig] = useState<AppConfig | null>(null);

	useEffect(() => {
		if (!config) {
			fetch('/environment')
				.then(HandleResponse)
				.then((cfg: AppConfig) => {
					if (isValidAppConfig(cfg)) {
						setConfig({
							...DEFAULT_APP_CONFIG,
							...cfg,
							API: buildAPI(cfg.API_URL)
						});
					} else {
						console.error('INVALID CONFIG:', cfg);
						setConfig(DEFAULT_APP_CONFIG);
					}
				})
				.catch(error => {
					console.warn('Failed to load /environment, using DEFAULT_APP_CONFIG:', error);
					setConfig(DEFAULT_APP_CONFIG);
				});
		}
	}, [config]);

	return config ? <AppRoutes config={config} /> : null;
}
